import React from 'react';
import { Network, ShieldAlert, Users } from 'lucide-react';

const NODES = [
  { id: 'c', x: 300, y: 210, r: 30, label: 'AZIENDA', main: true },
  { id: 'a', x: 120, y: 90, r: 16, label: 'Socio 60%' }, { id: 'b', x: 480, y: 80, r: 16, label: 'Amministratore' },
  { id: 'd', x: 100, y: 320, r: 16, label: 'Holding' }, { id: 'e', x: 500, y: 330, r: 16, label: 'Partecipata' },
  { id: 'f', x: 300, y: 380, r: 13, label: 'Titolare effettivo' }, { id: 'g', x: 560, y: 200, r: 12, label: 'PEP', alert: true },
  { id: 'h', x: 40, y: 200, r: 11, label: 'Ex socio' },
];
const EDGES = [['c', 'a'], ['c', 'b'], ['c', 'd'], ['c', 'e'], ['d', 'f'], ['b', 'g'], ['a', 'h'], ['e', 'g'], ['d', 'a']];
const at = (id) => NODES.find((n) => n.id === id);

export default function HomeGraph() {
  return (
    <section id="grafo" className="relative py-28 bg-[#050505] border-t border-[#1F1F1F] overflow-hidden" data-testid="home-graph">
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24 grid lg:grid-cols-12 gap-12 items-center">
        <div className="lg:col-span-5">
          <p className="font-mono text-xs uppercase tracking-[0.3em] text-[#D4AF37] mb-4">Il grafo delle relazioni</p>
          <h2 className="font-heading font-bold text-3xl sm:text-4xl text-white mb-6">Vedi i legami che i documenti non mostrano.</h2>
          <p className="text-base text-[#A3A3A3] leading-relaxed mb-8">Soci, amministratori, partecipazioni e catena di controllo in un'unica mappa interattiva: BOND individua i titolari effettivi e segnala i collegamenti con persone esposte o soggetti a rischio.</p>
          <ul className="space-y-4">
            {[[Network, 'Catena di controllo fino al titolare effettivo'], [Users, 'Esponenti attuali e cessati, aziende collegate'], [ShieldAlert, 'Collegamenti a rischio evidenziati in rosso']].map(([I, t]) => (
              <li key={t} className="flex items-center gap-3 text-sm text-[#D4D4D4]"><span className="w-9 h-9 grid place-items-center border border-[#D4AF37]/30 text-[#D4AF37]"><I size={16} /></span>{t}</li>
            ))}
          </ul>
        </div>
        <div className="lg:col-span-7 relative border border-[#D4AF37]/25 bg-[#0A0A0A] shadow-[0_0_40px_rgba(212,175,55,0.12)]">
          <svg viewBox="0 0 600 440" className="w-full h-auto" role="img" aria-label="Esempio di grafo delle relazioni">
            <defs><pattern id="hg" width="30" height="30" patternUnits="userSpaceOnUse"><path d="M30 0H0V30" fill="none" stroke="#1C1C1C" strokeWidth="0.6" /></pattern></defs>
            <rect width="600" height="440" fill="url(#hg)" />
            {EDGES.map(([s, t], i) => {
              const a = at(s); const b = at(t); const risk = at(t).alert;
              return <line key={i} x1={a.x} y1={a.y} x2={b.x} y2={b.y} stroke={risk ? '#C0392B' : '#D4AF37'} strokeOpacity={risk ? 0.8 : 0.45} strokeWidth="1.4" className="home-dash" style={{ animationDelay: `${i * 0.3}s` }} />;
            })}
            {NODES.map((n, i) => (
              <g key={n.id} className="home-node" style={{ animationDelay: `${i * 0.15}s` }}>
                {n.main && <circle cx={n.x} cy={n.y} r={n.r + 14} fill="#D4AF37" opacity="0.12" className="home-pulse" />}
                <circle cx={n.x} cy={n.y} r={n.r} fill={n.main ? '#D4AF37' : '#0A0A0A'} stroke={n.alert ? '#C0392B' : '#D4AF37'} strokeWidth="1.5" />
                <text x={n.x} y={n.y + n.r + 16} textAnchor="middle" fill={n.alert ? '#E57368' : '#A3A3A3'} fontSize="11" fontFamily="JetBrains Mono, monospace">{n.label}</text>
              </g>
            ))}
          </svg>
        </div>
      </div>
    </section>
  );
}
